
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button }from '@cmsgov/design-system';



const TagsManagerHeader = props => {

    const {
        openTagModal,
        tagsQty
    } = props;

    const createTag = () => {
        openTagModal();
    };

    return (
        <div className = 'margin-bottom-2em' data-testid = "tag_list_header_container">
            <span className='pull-left' data-testid = "tag_list_header_tagsQty">
                <FormattedMessage
                    id = 'ticket_management.tags_total'
                    values = {{ tagsQty }}
                />
            </span>
            <span className='pull-right' data-testid = "tag_list_header_create_new_tag_btn_container">
                <Button
                    className = 'usa-button gi-button gi-button__primary'
                    onClick = { createTag }
                    data-testid = "tag_list_header_create_new_tag_btn"
                >
                    <FormattedMessage id = 'button.crete_new_tag'/>
                </Button>
            </span>
        </div>
    );
};

export default TagsManagerHeader;